module.exports = __webpack_public_path__ + "img/Picture24.522e77a4.png";